export default __webpack_public_path__ + "static/media/lead1.aaee9755.svg";